import React ,{Component} from 'react'; 
import axios from 'axios'; 
import Serverurl from './Apiurl';
import {  DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';  
import Table from '@mui/material/Table';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
  
  

export default class CustomerattendenceReport extends Component{
	constructor(props) {
      super(props)
	  const now = dayjs();
const startOfMonth = now.startOf('month');
const today = now;
	     var strdob=new Date();
		  this.state = {CustomerData:[],page: 0 ,prevpage:0,totaldata:0,rowsPerPage:10,rowsPaging:[],classtype:'',sbid:'',smid:'',serachdate:'', orderdata: [],subscribeData:[],subscribeslotData:[], searchdate: dayjs().format('YYYY-MM-DD'), customerdata: [],branchid:'',classTypes:[]
		  ,fromdate: startOfMonth,
  fromdate1: startOfMonth.format('YYYY-MM-DD'),
  todate: today,
  todate1: today.format('YYYY-MM-DD'),}
	}
	
	handdateChanges = (date) => {
	
	  var month="";
 var date1 = new Date(date);
var todate1 = new Date(date);
	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}   
	 
	 todate1.setDate(date1.getDate() + 1);
	
     this.setState({ fromdate:dayjs(date),
fromdate1:date1.getFullYear() + '-' + month + '-' +date1.getDate(),
todate: todate1,
todate1:todate1.getFullYear() + '-' + month + '-' +todate1.getDate()
	 })
	
}
 handtodateChanges = (date) => {
	
	  var month="";
 var date1 = new Date(date);

	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}   
     this.setState({ todate:dayjs(date),
todate1:date1.getFullYear() + '-' + month + '-' +date1.getDate()
	 })
  }
  
  handleClickSearch=()=>{ 
this.setState({  
      page: 0,
      rowsPerPage:10,
	  prevpage:0,CustomerData:[],
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);
	 
	}); 
} 
  /*myChangeHandler = (event) => {
  const { name, value } = event.target;
  this.setState({ [name]: value }, () => {
    if (name === 'classtype') {
      this.filterDurations(value);
      this.setState({ smid: '', sbid: '' }); // Reset slot and duration
    } else if (name === 'sbid') {
      this.filterSlots(this.state.classtype, value);
      this.setState({ smid: '' }); // Reset slot
    }
  });
}*/

myChangeHandler = (event) => {
  const { name, value } = event.target;
  this.setState({ [name]: value }, () => {
    if (name === 'classtype') {
      this.filterSlots(value); 
      this.setState({ smid: '' }); 
    }
    
  });
};


componentDidMount  () {
	this.loadClassTypes();
	
}

formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

filterDurations = () => {
  axios.post(Serverurl + 'ajaxsubscription.php?action=getall&sb_type=' +this.state.classtype +'&sb_bm_id='+localStorage.getItem("AYLbrid")+'&sorting=sb_type')
    .then(resp => {
      if (resp.data.length > 0) {
        const formatted = resp.data.map(row => ({
          value: row.sb_id,
          display: row.sb_title,
         
        }));
        this.setState({
          subscribeData: [{ value: '', display: 'Select Duration' }, ...formatted]
        });
      } else {
        this.setState({ subscribeData: [] });
      }
    });
};

filterSlots = () => {
	
  axios.post(Serverurl + 'ajaxslotmanagement.php?action=getall&sm_slottype='+this.state.classtype+'&sbid='+this.state.sbid+'&sm_bm_id='+localStorage.getItem("AYLbrid")+'&sorting=sm_order asc')
    .then(resp => {
      if ( resp.data.length > 0) {
        const formatted = resp.data.map(row => ({
          value: row.sm_id,
          display: row.sm_slotname,
         
        }));
        this.setState({
          subscribeslotData: [{ value: '', display: 'Select Slot' }, ...formatted]
        });
      } else {
        this.setState({ subscribeslotData: [] });
      }
    });
};
loadClassTypes = () => {
  const branchId = localStorage.getItem("AYLbrid");

  axios.get(Serverurl + 'ajaxorders.php?action=list&or_bm_id=' + branchId)
    .then(resp => {
      if (resp.data.length > 0) {
        const classTypes = resp.data.map(row => ({
          value: row.or_classtype,
		  
        }));
        this.setState({ classTypes: classTypes });
      } else {
        this.setState({ classTypes: [] });
      }
    });
}

 apicall(page,rowsPerPage){
	 
	 axios.get(Serverurl+'ajaxcustomerschedule.php?action=getbydate&fromdate='+this.state.fromdate1+'&todate='+this.state.todate1+'&or_classtype='+this.state.classtype+'&or_sb_id='+this.state.sbid+'&or_sm_id='+this.state.smid+'&or_bm_id='+localStorage.getItem("AYLbrid")+'&StartIndex='+page+'&PageSize='+rowsPerPage)
     	
  .then(resp => {  
    if(resp.data.length>0){
		let copy=[50, 100, 150, 200, 250];
			this.setState({  
			  CustomerData: resp.data,  
			   totaldata:parseInt(resp.data[0].count),rowsPaging:copy
		    });
     }
	 else{
		   this.setState({CustomerData:[],totaldata:0});
	 }
 
    });
} 
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
  };
 handleChangePage = (event, newPage) => {  

    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  }; 
  
  
  render(){
	  return(
		  <React.Fragment>
		  <div className="boxheading">
				 
<h2>Attendance Report</h2>
</div>
 <div className="clear"></div>
		   <div className="searchmaster">
		   <ul>
		    <li>
 <p>From Date</p>

<p> <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.fromdate) }
className="txtbox" 
    onChange={this.handdateChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
</p>
 </li>
 
  <li>
 <p>To Date</p>

<p> <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.todate) }
className="txtbox" 
    onChange={this.handtodateChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
</p>
 </li> 
		    <li>
            <p>Class Type</p>
            <p>
              <FormControl className="stadrp">
                <Select
                  native
                  variant="outlined"
                  inputProps={{ tabIndex: "2" }}
                  className="txtbox"
                  margin="normal"
                  onChange={this.myChangeHandler}
                  id="type"
                  value={this.state.classtype}
                  name="classtype"
                >
                  <option value="">Select Your Type</option>
                  <option value={1}>Personal Training at Home</option>
                  <option value={2}>Personal Training in Studio</option>
                  <option value={3}>Group</option>
                  <option value={4}>Prenatal</option>
                  <option value={5}>Products</option>
                  <option value={6}>Personal Training Online</option>
                  <option value={7}>TTC</option>
                </Select>
              </FormControl>
            </p>
          </li>
		  {/*<li><p>Select Duration</p>
 
<Select
  className="txtbox"
  native
  value={this.state.sbid}
  onChange={this.myChangeHandler}
  name="sbid"
>
  {this.state.subscribeData.map((row, index) => (
    <option key={index} value={row.value}>
      {row.display}
    </option>
  ))}
</Select>
		  </li>*/}
		  <li><p>Select Slot</p>
 
 <Select
  className="txtbox"
  native
  value={this.state.smid}
  onChange={this.myChangeHandler}
  name="smid"
>
  {this.state.subscribeslotData.map((row, index) => (
    <option key={index} value={row.value}>
      {row.display}
    </option>
  ))}
</Select>
</li>
		 
 <li><p>
		<Button variant="contained" onClick={this.handleClickSearch} className="frmSecondarybtn" endIcon={<SearchIcon />}>
        Search
      </Button></p></li>
 </ul>
 </div>
 
 <div>

<Paper >


  <TableContainer>   
   <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
 <TableCell><strong>Date</strong></TableCell>
    <TableCell><strong>Name</strong></TableCell>
    <TableCell><strong>Email</strong></TableCell>
    <TableCell><strong>Class Type - Duration</strong></TableCell>
    <TableCell><strong>Slot</strong></TableCell>
    <TableCell><strong>Attendance</strong></TableCell>
                      </TableRow></TableHead>
					  
					 
                      <TableBody>
                   {Array.isArray(this.state.CustomerData) &&this.state.CustomerData.length > 0 &&
  this.state.CustomerData.map((item, index) => (
    <TableRow key={index}>
<TableCell>{this.formatDate(item.cs_date)}</TableCell>
      <TableCell>{item.or_name}</TableCell>
      <TableCell>{item.or_email}</TableCell>
      <TableCell>{item.classtype_duration}</TableCell>
      <TableCell>{item.slot}</TableCell>
      <TableCell>{item.attendence}</TableCell>
    </TableRow>
  ))
}
{this.state.totaldata===0 &&(
					
					<TableRow key={0}>
  <TableCell align="center" colSpan="6">No Records</TableCell>
</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
  component="div"  
  count={this.state.totaldata}  
  rowsPerPage={this.state.rowsPerPage}  
  page={this.state.page}  
  onPageChange={this.handleChangePage}  
  onRowsPerPageChange={this.handleChangeRowsPerPage}  
/>

  </Paper>
    </div>
 </React.Fragment> 

 
 
 
	  );
  }


}